import React from 'react';
import Section from '@components/Section';
import styles from './Experience.module.scss';

function formatDate(date) {
  if (!date.month) {
    return date.year;
  }

  const instance = new Date(date.year, date.month - 1, 1);
  const month = instance.toLocaleString('default', { month: 'short' });

  return `${month} ${date.year}`;
}

function OrganizationDetails({ organization }) {
  if (!organization.start && !organization.end) {
    return null;
  }

  return (
    <span className="information-item">
      {!organization.start ? null : formatDate(organization.start)} -{' '}
      {!organization.end ? 'Current' : formatDate(organization.end)}
    </span>
  );
}

export default function Experience({ contact, underline = true }) {
  if (!contact.organizations || contact.organizations.length === 0) {
    return null;
  }

  return (
    <Section>
      <Section.Title underline={underline}>Experience</Section.Title>
      {contact.organizations.map((organization, i) => (
        <div className={styles.organization} key={i}>
          {!organization.title ? (
            <div className="title">{organization.name}</div>
          ) : (
            <>
              <div className="title">{organization.title}</div>
              <div className="information">
                {organization.name && <span className="information-item">{organization.name}</span>}
                <OrganizationDetails organization={organization} />
              </div>
              {organization.description && (
                <div className={styles.description}>{organization.description}</div>
              )}
            </>
          )}
        </div>
      ))}
    </Section>
  );
}
